module.exports = __webpack_public_path__ + "img/logo-carbon.2f97d6b1.svg";